import axios from "@/libs/api.request";

export const getExtractConfig = params => {
  return axios.request({
    url: "/extract/extractHandle/getExtractConfig",
    method: "get",
    params
  });
};

export const postPack = data => {
  return axios.request({
    url: "/warehouse/packing/getAirwayNumber",
    method: "post",
    data
  });
};

export const add = data => {
  return axios.request({
    url: "/extract/extract",
    method: "post",
    data
  });
};

export const getExtractException = id => {
  return axios.request({
    url: `/extract/extractHandle/getExtractException/${id}`,
    method: "get"
  });
};

export const getExtractNotWarehouse = id => {
  return axios.request({
    url: `/extract/extractHandle/getExtractNotWarehouse/${id}`,
    method: "get"
  });
};

export const getClearancePacking = params => {
  return axios.request({
    url: `/extract/extractHandle/getClearancePacking`,
    method: "get",
    params
  });
};

// 获取b2b中港单号
export const getB2bAirwayNumber = params => {
  return axios.request({
    url: `/extract/getDblOrder`,
    method: "get",
    params
  });
};

export const getAirPort = params => {
  return axios.request({
    url: `/common/getAirPort`,
    method: "get",
    params
  });
};
